import { render, staticRenderFns } from "./DevIllustrationContextMenu.vue?vue&type=template&id=63b94896"
import script from "./DevIllustrationContextMenu.vue?vue&type=script&lang=js"
export * from "./DevIllustrationContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports